import { Link } from 'react-router-dom';
import AnimeCard from '@/components/feature/AnimeCard';
import { animeList } from '@/mocks/anime';

export default function HotSection() {
  const hot = [...animeList].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门推荐
            <span className="ml-2 align-middle text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 font-medium">
              高人气
            </span>
          </h2>
          <p className="text-sm text-foreground-500 mt-1">根据播放量与评分精选，追番不踩雷</p>
        </div>
        <Link
          to="/category/热血"
          className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
        >
          更多热门
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {hot.map((anime, i) => (
          <AnimeCard key={anime.id} anime={anime} rank={i + 1} />
        ))}
      </div>
    </section>
  );
}